var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmation"},[_c('div',{staticClass:"container"},[_c('div',[_vm._v(_vm._s(this.message))]),_c('p'),_c('p')])])
}
var staticRenderFns = []

export { render, staticRenderFns }